import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nova_to_right_icon",
  "use": "icon-nova_to_right_icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" id=\"icon-nova_to_right_icon\">\n  <path d=\"M9.57433 3.3246C9.1838 2.93414 8.55077 2.9341 8.16027 3.3246C7.76984 3.7151 7.76984 4.34815 8.16027 4.73866L15.4376 12.016L8.16027 19.2933C7.76997 19.6839 7.76982 20.317 8.16027 20.7074C8.55073 21.0978 9.18382 21.0977 9.57433 20.7074L17.5587 12.723C17.9492 12.3325 17.9492 11.6995 17.5587 11.309L9.57433 3.3246Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol